// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eb23188c","239":"2a8f0f8a","453":"e2a7b7c0","732":"5466f176"}[chunkId] + ".chunk.js";
};